import { Component, ViewChild } from "@angular/core";
import { IHeaderAngularComp } from "ag-grid-angular";
import { IHeaderParams } from "ag-grid-community";
import {
  ContextMenuComponent,
  ContextMenuService,
} from "@perfectmemory/ngx-contextmenu";
import { ContextMenuOpenAtPositionOptions } from "@perfectmemory/ngx-contextmenu/lib/services/context-menu/context-menu.service";

@Component({
  selector: "ag-grid-evrideo-select-all-header-column",
  templateUrl: `./ag-grid-evrideo-select-all-header-column.component.html`,
  styleUrls: ["./ag-grid-evrideo-select-all-header-column.component.scss"],
})
export class AgGridEvrideoSelectAllHeaderColumnComponent
  implements IHeaderAngularComp
{
  isChecked: boolean = false;
  isIndeterminate: boolean = false;
  isDisabled: boolean = false;
  contextMenuOpen: boolean = false;
  selectionType = "all";
  params: any;
  @ViewChild(ContextMenuComponent) public basicMenu;

  constructor(
    private contextMenuService: ContextMenuService<AgGridEvrideoSelectAllHeaderColumnComponent>,
  ) {}

  refresh(params: IHeaderParams) {
    return false;
  }
  agInit(params: IHeaderParams): void {
    this.params = params;
    this.params.api.addEventListener("selectionChanged", () => {
      this.setCheckboxState();
    });
  }

  toggleSelect() {
    if (this.isChecked) {
      let firstRow = 0;
      let lastRow =
        this.params?.context.componentParent.gridOptions.rowModelType ==
        "infinite"
          ? this.params?.api?.getInfiniteRowCount()
          : this.params?.api?.getRowCount();
      if (this.selectionType == "page") {
        firstRow = this.params?.api?.paginationProxy.getPageFirstRow();
        lastRow = this.params.api.paginationProxy.getPageLastRow();
      }

      this.params?.api?.forEachNode((node) => {
        if (node.rowIndex >= firstRow && node.rowIndex <= lastRow) {
          node.selectThisNode(true);
        }
      });

      const event: any = {
        type: "selectionChanged",
        api: this.params.api,
        columnApi: this.params.columnApi,
      };

      this.params?.api?.eventService?.dispatchEvent(event);
    } else {
      this.params.api.deselectAll();
    }
  }
  SetSelection(type) {
    this.selectionType = type;
    this.params?.api?.deselectAll();
    this.isChecked = true;
    this.toggleSelect();
  }
  onContextMenu($event: MouseEvent): void {
    this.contextMenuOpen = true;
    const pos = {
      value: this.basicMenu,
      x: $event.x,
      y: $event.y,
    } as ContextMenuOpenAtPositionOptions<any>;
    this.contextMenuService.closeAll();
    this.contextMenuService.show(this.basicMenu, pos);
    $event.preventDefault();
    $event.stopPropagation();
  }

  setCheckboxState() {
    const selectedNodesLength: number =
      this.params?.api?.getSelectedNodes()?.length;
    let renderedNodesLength: number = 0;
    this.params?.api?.forEachNode((n) => {
      renderedNodesLength++;
    });

    this.isChecked =
      selectedNodesLength > 0 && selectedNodesLength === renderedNodesLength;
    this.isIndeterminate = selectedNodesLength > 0 && !this.isChecked;
  }
}
